export class Vector2D {
  constructor(public x: number, public y: number) {}
}
